export enum actionTypes {
    CONFIG_UPDATE = 'CAROUSEL:CONFIG:UPDATE',
    CONTAINER_SHIFT_UPDATE = 'CAROUSEL:CONTAINER_SHIFT:UPDATE',
    ITEM_SHIFT_UPDATE = 'CAROUSEL:ITEM_SHIFT:UPDATE',
    ITEM_WIDTH_UPDATE = 'CAROUSEL:ITEM_WIDTH:UPDATE',
    MOVE_LEFT = 'CAROUSEL:MOVE:LEFT',
    MOVE_RIGHT = 'CAROUSEL:MOVE:RIGHT',
    NUMERATION_DATA_UPDATE = 'CAROUSEL:NUMERATION_DATA:UPDATE',
    SLIDES_COUNT_UPDATE = 'CAROUSEL:SLIDES_COUNT:UPDATE',
    TOGGLE_RESTART = 'CAROUSEL:TOGGLE_RESTART'
}
